export class ListPessoaIdsRequest {
    listIdPessoa: number[];
}